<template>
  <v-sheet>
    <v-card>
      <v-card-title><h2>Nowa akcja</h2></v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">

            <v-select v-model="subscriberSelected" label="Rodzaj akcji"
                      :items="subscriberTypes"
                      @change="initModel()"
                      item-text="description"
                      item-value="name"
            ></v-select>

            <v-select v-model="eventType" label="Wydarzenie"
                      v-if="subscriberSelected"
                      :items="EventActionType
                      .getEventsToSelect(subscriberTypes.find(el => el.name == subscriberSelected).properties.allowedEvents)"
                      item-text="name"
                      item-value="value"
            ></v-select>

            <div v-for="(field,key) in getActionFields(subscriberSelected)" :key="'action-field-' + key">

              <div v-if="field.type == 'multiFieldList'">
                <h3>{{ field.description }}</h3>
                <div>
                  <v-icon @click="addSubFieldsForMultiField(field)">add</v-icon>
                  <v-icon @click="removeSubFieldsForMultiField(field)">remove</v-icon>
                </div>

                <div v-for="(_,i) in field.length != undefined ? field.length : 0">
                  <h4>{{ i + 1 }}</h4>
                  <FieldElement v-for="(__,j) in field.options.subFields.length"
                                v-model="model[field.name][i][field.options.subFields[j].name]"
                                :element-types="subscriberTypes"
                                :foreign-schema="foreignSchema"
                                :field="field.options.subFields[j]" :schema="schema"
                                :schemas="schemas" :templates="templates" @schemaChanged="schemaChanged($event)">

                  </FieldElement>

                </div>
              </div>

              <FieldElement v-else v-model="model[field.name]"
                            :element-types="subscriberTypes"
                            :field="field" :schema="schema"
                            :foreign-schema="foreignSchema"
                            :schemas="schemas" :templates="templates" @schemaChanged="schemaChanged($event)">
              </FieldElement>

            </div>

            <v-btn @click="submit()">Ok</v-btn>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import eventActionType from "../../../enums/eventActionType"
import ColorPicker from '@radial-color-picker/vue-color-picker'
import color from "@/mixins/color"
import FieldElement from "../elements/Field.vue"
import Vue from "vue"

export default {
  mixins: [color],
  props: ['subscriberTypes', 'schema', 'templates'],
  components: {FieldElement, ColorPicker},
  data() {
    return {
      subscriberSelected: null,
      model:{},
      foreignSchema: {},
      schemas: [],
      eventType: null,
      EventActionType: eventActionType
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    },
    foreignFields() {
      if (!this.foreignSchema || this.foreignSchema == undefined) {
        return []
      }

      return this.getFields(false, this.foreignSchema.fields)
    },
    tableFields() {
      return this.getTableFields(this.schema.fields)
    },
    fields() {
      return this.getAllFields(this.schemaFields)
    }
  },
  created() {
    this.$http.get('/schemas').then(data => {
      this.schemas = data.data
    })
  },
  methods: {
    schemaChanged(id) {
      this.$http.get(`/schema/${id}`).then(data => {
        this.foreignSchema = data.data
      })
    },
    addSubFieldsForMultiField(field) {
      if (this.model[field.name] == undefined) {
        this.model[field.name] = []
        Vue.set(field, "length", 0)
      }

      let obj = {}
      field.options.subFields.forEach(sf => obj[sf.name] = "")
      this.model[field.name].push(obj)
      Vue.set(field, "length", field.length + 1)
    },
    removeSubFieldsForMultiField(field) {
      if (this.model[field.name] != undefined) {
        this.model[field.name].splice(-1)
        Vue.set(field, "length", field.length - 1)
      }
    },
    getFields(type, fields) {
      let fieldsToFilter = fields != undefined ? fields : this.schema.fields
      return fieldsToFilter.filter(field => field.type != 'table' && type ? field.type == type : true)
    },
    getAllFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getTableFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getInputType(type){
      switch (type){
      case "integer" :
        return "number"
      case "relatedValueKey" :
        return "number"
      default :
        return "text"
      }
    },
    initModel() {
      this.model = {}
      this.getActionFields(this.subscriberSelected).forEach(actionField => {
        if (Object.hasOwn(actionField, 'initValue')) {
          this.model[actionField.name] = actionField.initValue
        }
      })
    },
    getActionPropertyDescription(actionType, propertyName){
      let action = this.subscriberTypes.find(el => el.name == actionType)
      let property = action ? action.properties.fields.find(el => el.name == propertyName) : null
      return property ? property.description : "Nieznana własciwość"
    },
    getActionFields(type){
      let action = this.subscriberTypes.find(el => el.name == type)
      return action ? action.properties.fields : []
    },
    submit() {
      if (!this.eventType || !this.subscriberSelected) {
        return
      }

      let postData = {
        'subscriber': this.subscriberSelected,
        'event': this.eventType,
        'data': this.model
      }
      this.$http.post(`schema/${this.$route.params.schemaId}/subscriber`, postData).then(data => {
        this.$emit('subscriberCreated',data.data)
        this.$store.commit('setSnack', {
          message: "Dodano akcje",
          color: 'success'
        })

        // this.$router.push({name: 'schema-related-map', params: {schemaId: this.$route.params.schemaId}})
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Nie można dodać akcji",
          color: 'error'
        })
      })
    },
  },
}
</script>
<style>
@import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
</style>
